<div class="body_container text-grey"
     [ngClass]="currentEntity == 'Configurator' ? 'configuratorView' : ''">
  <div class="listHeader" *ngIf="currentEntity != 'Configurator'">
    <h4>Deployment List</h4>
    <button type="button"
            *ngIf="isUserGlobalAdmin"
            title="Create new deployment"
            class="default-btn"
            style="float: right"
            routerLink="new">
      <span class="bi bi-plus-lg"></span>
      New Deployment
    </button>
  </div>

  <table class="table table-hover" style="white-space: nowrap;"
         [ngClass]="currentEntity != 'Configurator' ? 'main-panel-table' : ''">
    <thead>
      <tr class="table-list-head">
        <th resizable scope="col">#</th>
        <th resizable scope="col">
          Name
          <span style="cursor: pointer" [ngClass]="
                  sortName == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByName()"></span>
        </th>
        <th resizable scope="col">
          Location
          <span style="cursor: pointer" [ngClass]="
                  sortLocation == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByLocation()"></span>
        </th>
        <th resizable scope="col">
          Scheduler
          <span style="cursor: pointer" [ngClass]="
                  sortScheduler == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByScheduler()"></span>
        </th>
        <th resizable scope="col">
          Infrastructure
          <span style="cursor: pointer" [ngClass]="
                  sortInfrastructure == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByInfrastructure()"></span>
        </th>
        <th resizable scope="col">
          Status
          <span style="cursor: pointer" [ngClass]="
                  sortStatus == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByStatus()"></span>
        </th>
        <!-- <th resizable scope="col">License State
          <span style="cursor: pointer" [ngClass]="
                  sortLicenseState == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByLicenseState()">
          </span>
        </th> -->
        <th *ngIf="isPathConfigurator" resizable scope="col"></th>
      </tr>
    </thead>
    <tbody *ngIf="!dataEmpty">
      <!-- (click)="redirectTo(dep.cloud ,dep.name)" -->
      <tr class="table-list-row"
         *ngFor="let dep of deployments | paginate: { itemsPerPage: 10, currentPage: p }; let i = index"
          style="cursor: pointer; outline: none; vertical-align: middle;">
        <td scope="row" *ngIf="p == 1">{{ i + 1 }}</td>
        <td scope="row" *ngIf="p != 1">
          {{ (p - 1) * 10 + (i + 1) }}
        </td>
        <td (click)="redirectTo(dep)" class="impListName">
          {{ dep.name }}
        </td>
        <td (click)="redirectTo(dep)">{{ dep.location || 'NA' }}</td>
        <td (click)="redirectTo(dep)">{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  'NA' : dep.scheduler}}</td>
        <td (click)="redirectTo(dep)">{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  dep.cloud + ": VDI" : dep.cloud}}</td>

        <td (click)="redirectTo(dep)">
          <label for="" title="{{dep.status}}">{{ dep.status || 'NA' | splitWord }}</label>
        </td>
        <!-- <td (click)="redirectTo(dep)">
          <div style="width:100%; display:flex; justify-content:flex-start; align-items:center">
            <div style="width:5px; height:5px; border-radius:50%; margin-right: 7px; display:inline-block"
                 [ngStyle]="{'background-color': dep.licenseConnectivityColorCode? dep.licenseConnectivityColorCode: ''}">
            </div>
            {{dep.licenseConnectivity}}
          </div>
        </td> -->
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="deployments"
    class="my-pagination"
    (pageChange)="p = $event">
  </pagination-controls>
  <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%">
    No Deployment Available.
  </p>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
      size="default" zIndex="1"
      color="var(--s-primary-color)"
      type="ball-spin"
      [fullScreen]="false"><p>Please wait ...</p></ngx-spinner>
</div>
